// extracted by mini-css-extract-plugin
module.exports = {"appHeader":"AppHeader_appHeader__1wmf-","appTitle":"AppHeader_appTitle__bMQf4"};